/*
  PaniHome — module de panier.

  Transpose depuis l implementation de reference, dont la logique a fait ses
  preuves en production. Ce qui a ete RETIRE : paliers de recompense, cadeau
  offert, barre de progression, moteur de recommandations, et le contournement
  specifique a WideBundle (application non installee sur PaniHome, verifie).
  Ce qui a ete GARDE : tout le reste, a l identique.

  Principe directeur : AMELIORATION PROGRESSIVE.
  Le site fonctionne sans ce fichier. Les formulaires d ajout sont natifs et
  pointent vers /cart/add, l icone du header est un vrai lien vers /cart. Ce
  module se contente d intercepter ces actions QUAND il y parvient. Toute
  erreur — reseau, JSON, exception — laisse le comportement natif reprendre la
  main plutot que d afficher un panier a moitie fonctionnel.

  Source unique de verite : l API panier de Shopify. Aucun etat parallele.
*/
(function () {
  'use strict';

  var racine = document.querySelector('[data-phcart]');
  if (!racine) return;

  var FORMAT = racine.getAttribute('data-format-monnaie') || '{{amount}} €';
  var URL_PANIER = racine.getAttribute('data-url-panier') || '/cart';
  var URL_ACCESSOIRES = racine.getAttribute('data-url-accessoires') || '';

  var liste = racine.querySelector('[data-phcart-liste]');
  var vide = racine.querySelector('[data-phcart-vide]');
  var pied = racine.querySelector('[data-phcart-pied]');
  var compte = racine.querySelector('[data-phcart-compte]');
  var bulle = racine.querySelector('[data-phcart-bulle]');
  var bulleCompte = racine.querySelector('[data-phcart-bulle-compte]');
  var zoneLivraison = racine.querySelector('[data-phcart-livraison]');
  var zoneReco = racine.querySelector('[data-phcart-upsell]');
  var zoneCarrousel = racine.querySelector('[data-phcart-carrousel]');

  var enCours = false;      // anti double-clic / double-ajout
  var dernierFocus = null;

  /* ------------------------------------------------------------------ */
  /* Formatage monetaire                                                 */
  /* ------------------------------------------------------------------ */
  // On reproduit le format de la boutique plutot que d imposer le notre : le
  // total du tiroir doit correspondre au centime pres a celui du paiement.
  // Shopify propose cinq marqueurs de format ; on les gere tous plutot que de
  // supposer lequel est actif.
  function prix(centimes) {
    var n = centimes / 100;
    var grouper = function (entier, sep) {
      return entier.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    };
    var avecDecimales = function (sepDecimal, sepMillier) {
      var parts = n.toFixed(2).split('.');
      return grouper(parts[0], sepMillier) + sepDecimal + parts[1];
    };
    var sansDecimales = function (sepMillier) {
      return grouper(Math.round(n).toString(), sepMillier);
    };
    var valeurs = {
      amount: avecDecimales('.', ','),
      amount_no_decimals: sansDecimales(','),
      amount_with_comma_separator: avecDecimales(',', '.'),
      amount_no_decimals_with_comma_separator: sansDecimales('.'),
      amount_with_apostrophe_separator: avecDecimales('.', String.fromCharCode(39))
    };
    var sortie = FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (tout, cle) {
      return Object.prototype.hasOwnProperty.call(valeurs, cle) ? valeurs[cle] : tout;
    });
    // Aucun marqueur reconnu : on rend un montant brut plutot que rien.
    return sortie === FORMAT ? valeurs.amount_with_comma_separator + ' €' : sortie;
  }

  /* ------------------------------------------------------------------ */
  /* Appels a l API panier                                               */
  /* ------------------------------------------------------------------ */
  function appel(url, corpsRequete) {
    var options = {
      method: corpsRequete ? 'POST' : 'GET',
      // En-tete de reconnaissance : le filet reseau pose plus bas doit
      // pouvoir distinguer nos appels de ceux des applications tierces,
      // sinon il se declencherait sur lui-meme.
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-PaniHome-Panier': '1'
      },
      credentials: 'same-origin'
    };
    if (corpsRequete) options.body = JSON.stringify(corpsRequete);
    return fetch(url, options).then(function (r) {
      if (!r.ok) throw new Error('reponse ' + r.status);
      return r.json();
    });
  }

  var lire = function () { return appel('/cart.js'); };
  var ajouter = function (items) { return appel('/cart/add.js', { items: items }); };
  var changer = function (cle, quantite) {
    return appel('/cart/change.js', { id: cle, quantity: quantite });
  };

  function echapper(t) {
    var d = document.createElement('div');
    d.textContent = t == null ? '' : String(t);
    return d.innerHTML;
  }

  /* ------------------------------------------------------------------ */
  /* Rendu                                                               */
  /* ------------------------------------------------------------------ */
  // Contenu interieur d une ligne d article, reutilise a l identique par une
  // ligne normale (ligne()) et par une ligne a l interieur d un pack (voir
  // cartePack() plus bas) — memes classes, memes controles.
  function contenuArticle(article) {
    var image = article.image
      ? article.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')
      : '';

    // La variante n est affichee que si elle existe reellement : Shopify
    // renvoie « Default Title » pour les produits sans declinaison.
    var variante = article.variant_title && article.variant_title !== 'Default Title'
      ? '<span class="phcart-article__variante">' + echapper(article.variant_title) + '</span>'
      : '';

    // Cadeau automatique (brosse demelante des 80€) : propriete de ligne
    // prefixee "_" (masquee par Shopify au client/a la commande, lisible ici
    // via l API). Pas de +/- : la quantite est geree par gererCadeauBrosse,
    // jamais par le client.
    var estCadeau = !!(article.properties && article.properties._cadeau_offert_80e);
    var quantiteOuBadge = estCadeau
      ? '<span class="phcart-article__badge">Offert dès 80 €</span>'
      : '<div class="phcart-article__quantite">' +
          '<button type="button" data-phcart-qte="-1" aria-label="Diminuer la quantité">−</button>' +
          '<span data-phcart-qte-valeur>' + article.quantity + '</span>' +
          '<button type="button" data-phcart-qte="1" aria-label="Augmenter la quantité">+</button>' +
        '</div>';

    return (
      '<div class="phcart-article__visuel">' +
        (image ? '<img src="' + image + '" alt="" width="78" height="78" loading="lazy">' : '') +
      '</div>' +
      '<div class="phcart-article__infos">' +
        '<a class="phcart-article__titre" href="' + article.url + '">' + echapper(article.product_title) + '</a>' +
        variante +
        '<div class="phcart-article__bas">' +
          quantiteOuBadge +
          // final_line_price, jamais le prix catalogue : c est le montant
          // reellement facture, remises comprises.
          '<span class="phcart-article__prix">' + prix(article.final_line_price) + '</span>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="phcart-article__retirer" data-phcart-retirer aria-label="Retirer cet article">' +
        '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M3 3l8 8M11 3l-8 8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
      '</button>'
    );
  }

  function ligne(article) {
    var li = document.createElement('li');
    li.className = 'phcart-article';
    li.setAttribute('data-cle', article.key);
    li.innerHTML = contenuArticle(article);
    return li;
  }

  /* ---------- Pack Confort (panier + son plaid taille-matche) ---------- */
  // Demande explicite du 26/09/2026 : quand un panier et le plaid qui lui
  // correspond sont tous les deux dans le tiroir, les regrouper visuellement
  // plutot que deux lignes independantes. Le "match" reutilise le meme
  // mapping.json que les recommandations — pas une regle separee : un panier
  // ne s associe qu au plaid EXACTEMENT recommande pour sa taille, jamais a
  // un plaid pris au hasard qui trainerait dans le panier pour une autre
  // raison.
  function construirePaires(panier, data) {
    var paires = []; // { panierKey, plaidKey }
    if (!data || !data.mapping || !data.plaid) return paires;
    var plaidDejaApparie = {};
    for (var i = 0; i < panier.items.length; i++) {
      var art = panier.items[i];
      var info = data.mapping[String(art.variant_id)];
      if (!info || !info.plaid) continue;
      var fichePlaid = data.plaid[info.plaid];
      if (!fichePlaid) continue;
      for (var j = 0; j < panier.items.length; j++) {
        var autre = panier.items[j];
        if (autre.key === art.key) continue;
        if (String(autre.variant_id) === String(fichePlaid.variantId) && !plaidDejaApparie[autre.key]) {
          paires.push({ panierKey: art.key, plaidKey: autre.key });
          plaidDejaApparie[autre.key] = true;
          break;
        }
      }
    }
    return paires;
  }

  function cartePack(articlePanier, articlePlaid) {
    var li = document.createElement('li');
    li.className = 'phcart-pack';
    li.innerHTML =
      '<p class="phcart-pack__titre">Pack Confort</p>' +
      '<div class="phcart-article phcart-pack__article" data-cle="' + echapper(articlePanier.key) + '">' + contenuArticle(articlePanier) + '</div>' +
      '<div class="phcart-article phcart-pack__article" data-cle="' + echapper(articlePlaid.key) + '">' + contenuArticle(articlePlaid) + '</div>';
    return li;
  }

  // Rendu de la liste : async car il depend de panihome-accessoires.json
  // (deja charge/en cache la plupart du temps). En cas d echec, repli sur
  // une liste simple sans regroupement plutot que sur rien.
  function construireListe(panier) {
    chargerAccessoires().then(function (data) {
      var paires = construirePaires(panier, data);
      var parCle = {};
      for (var p = 0; p < paires.length; p++) {
        parCle[paires[p].panierKey] = paires[p];
        parCle[paires[p].plaidKey] = paires[p];
      }
      var index = {};
      for (var k = 0; k < panier.items.length; k++) index[panier.items[k].key] = panier.items[k];

      liste.innerHTML = '';
      var traites = {};
      for (var i = 0; i < panier.items.length; i++) {
        var art = panier.items[i];
        if (traites[art.key]) continue;
        var paire = parCle[art.key];
        if (paire && index[paire.panierKey] && index[paire.plaidKey]) {
          liste.appendChild(cartePack(index[paire.panierKey], index[paire.plaidKey]));
          traites[paire.panierKey] = true;
          traites[paire.plaidKey] = true;
        } else {
          liste.appendChild(ligne(art));
          traites[art.key] = true;
        }
      }
    }).catch(function () {
      liste.innerHTML = '';
      for (var i = 0; i < panier.items.length; i++) liste.appendChild(ligne(panier.items[i]));
    });
  }

  function ecrire(selecteur, texte) {
    var el = racine.querySelector(selecteur);
    if (el) el.textContent = texte;
  }

  // Le compteur du header est un element du theme, pas du tiroir. Kalles le
  // rafraichissait par son propre AJAX, que nous avons desactive : c est donc
  // a nous de le tenir a jour. Sans cela le client ajoute un article, voit une
  // icone a zero, et recommence.
  //
  // t4s-op-0 est la classe d opacite nulle du theme : c est ainsi qu il masque
  // la pastille quand le panier est vide.
  function majCompteurTheme(n) {
    var cibles = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < cibles.length; i++) {
      cibles[i].textContent = n;
      if (n > 0) cibles[i].classList.remove('t4s-op-0');
      else cibles[i].classList.add('t4s-op-0');
    }
  }

  // Reductions appliquees : on reprend les intitules de Shopify plutot que
  // d en inventer. Le client doit lire dans le tiroir exactement ce qu il
  // relira au paiement.
  function rendreReductions(panier) {
    var zone = racine.querySelector('[data-phcart-reductions]');
    if (!zone) return;
    var appliquees = panier.cart_level_discount_applications || [];
    if (!appliquees.length) { zone.hidden = true; zone.innerHTML = ''; return; }
    var html = '';
    for (var i = 0; i < appliquees.length; i++) {
      // Filet defensif : /cart.js rend ces objets a plat, mais /cart/add.js,
      // /cart/change.js et /cart/update.js les imbriquent sous
      // `discount_application` — si jamais une reponse brute de ces
      // endpoints atterrissait ici malgre le re-fetch de majQuantite, on
      // reste correct plutot que d afficher "NaN,undefined".
      var d = appliquees[i].discount_application || appliquees[i];
      if (!d || !d.title) continue;
      html += '<div class="phcart__ligne phcart__ligne--reduction">' +
                '<dt>' + echapper(d.title) + '</dt>' +
                '<dd>−' + prix(d.total_allocated_amount) + '</dd>' +
              '</div>';
    }
    zone.innerHTML = html;
    zone.hidden = false;
  }

  /* ------------------------------------------------------------------ */
  /* Accessoires (plaid / tapis / rouleau) — zone "Complétez son confort"  */
  /* ------------------------------------------------------------------ */
  // Depuis le 25/09/2026, ce bloc ne propose plus d autres paniers : il
  // propose les 3 accessoires du chantier AOV, au prix duo (-40 %) des qu un
  // panier eligible est present dans le panier. Hierarchie voulue par Sami :
  // plaid = choix principal par defaut, tapis = recommandation contextuelle
  // (selon l eligibilite calculee a l etape 2), rouleau = option secondaire
  // systematique (aucune taille, toujours pertinent).
  var accessoiresPromesse = null;
  function chargerAccessoires() {
    if (!URL_ACCESSOIRES) return Promise.resolve(null);
    if (accessoiresPromesse) return accessoiresPromesse;
    accessoiresPromesse = fetch(URL_ACCESSOIRES, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return accessoiresPromesse;
  }

  // Le premier article du panier qui correspond a un panier connu du
  // mapping fait foi pour la taille recommandee. Cas non couvert par le
  // brief : plusieurs paniers de tailles differentes dans le meme panier —
  // on retient alors le premier, pas une fusion des deux.
  function panierCorrespondant(panier, mapping) {
    for (var i = 0; i < panier.items.length; i++) {
      var infos = mapping[String(panier.items[i].variant_id)];
      if (infos) return infos;
    }
    return null;
  }

  function dejaDansLePanier(panier, variantId) {
    for (var i = 0; i < panier.items.length; i++) {
      if (String(panier.items[i].variant_id) === String(variantId)) return true;
    }
    return false;
  }

  // Prix duo abandonne le 26/09/2026 (Sami : "garde la brosse offerte,
  // laisse tomber le duo") — aucune remise Shopify ne peut faire coexister
  // le duo accessoire avec le cadeau brosse sur ce compte (voir memoire du
  // chantier). La carte redevient une simple recommandation au prix
  // catalogue : plus de barre, plus de "Économisez X", rien qui promette
  // une remise que la caisse n applique pas.
  function carteAccessoire(fiche, eyebrow, principale) {
    var centimesNormal = Math.round(fiche.prix * 100);
    var visuel = fiche.image ? fiche.image.replace(/(\.[a-z]+)(\?|$)/i, (principale ? '_128x' : '_96x') + '$1$2') : '';
    var url = '/products/' + fiche.handle;
    var classe = 'phcart-access ' + (principale ? 'phcart-access--principale' : 'phcart-access--secondaire');
    return '<li class="' + classe + '">' +
      (visuel ? '<a class="phcart-access__visuel" href="' + url + '"><img src="' + echapper(visuel) + '" alt="" loading="lazy" width="' + (principale ? 64 : 48) + '" height="' + (principale ? 64 : 48) + '"></a>' : '') +
      '<div class="phcart-access__infos">' +
        '<span class="phcart-access__eyebrow">' + echapper(eyebrow) + '</span>' +
        '<a class="phcart-access__titre" href="' + url + '">' + echapper(fiche.produit) + (fiche.taille ? ' — Taille ' + fiche.taille : '') + '</a>' +
        '<div class="phcart-access__prix"><strong>' + prix(centimesNormal) + '</strong></div>' +
      '</div>' +
      '<button type="button" class="phcart-access__action" data-phcart-reco="' + fiche.variantId + '">Ajouter</button>' +
    '</li>';
  }

  function cacherAccessoires() {
    if (!zoneReco) return;
    zoneReco.hidden = true;
    zoneReco.innerHTML = '';
  }

  function recommanderAccessoires(panier) {
    if (!zoneReco) return Promise.resolve();
    if (!panier.item_count) { cacherAccessoires(); return Promise.resolve(); }

    return chargerAccessoires().then(function (data) {
      if (!data) { cacherAccessoires(); return; }
      var correspondance = panierCorrespondant(panier, data.mapping);
      // Aucun panier reconnu dans le panier (uniquement des accessoires, ou
      // un produit hors du catalogue mappe) : rien a recommander, le prix
      // duo n a de sens qu accole a un panier eligible.
      if (!correspondance) { cacherAccessoires(); return; }

      var candidats = [];
      if (correspondance.plaid && data.plaid[correspondance.plaid]) {
        candidats.push({ role: 'plaid', fiche: data.plaid[correspondance.plaid], eyebrow: 'Le choix qui lui va' });
      }
      if (correspondance.tapis && data.tapis[correspondance.tapis]) {
        candidats.push({ role: 'tapis', fiche: data.tapis[correspondance.tapis], eyebrow: 'Pour les jours de chaleur' });
      }
      candidats.push({ role: 'rouleau', fiche: data.rouleau, eyebrow: 'On y pense rarement' });

      candidats = candidats.filter(function (c) { return !dejaDansLePanier(panier, c.fiche.variantId); });
      if (!candidats.length) { cacherAccessoires(); return; }

      // Hierarchie : le plaid reste le choix principal par defaut ; a
      // defaut (deja au panier, ou panier hors perimetre plaid), le rouleau
      // prend sa place, puis le tapis. Ordre des secondaires inverse le
      // 26/09/2026 sur demande explicite de Sami (upsell plus naturel avec
      // le rouleau en premier).
      var ordre = { plaid: 0, rouleau: 1, tapis: 2 };
      candidats.sort(function (a, b) { return ordre[a.role] - ordre[b.role]; });
      var principal = candidats[0];
      var secondaires = candidats.slice(1);

      var html = '<p class="phcart__upsell-titre">Complétez son confort</p><ul class="phcart-access-liste">';
      html += carteAccessoire(principal.fiche, principal.eyebrow, true);
      if (secondaires.length) {
        html += '</ul><div class="phcart-access__secondaires"><ul class="phcart-access-liste">';
        for (var i = 0; i < secondaires.length; i++) html += carteAccessoire(secondaires[i].fiche, secondaires[i].eyebrow, false);
        html += '</ul></div>';
      } else {
        html += '</ul>';
      }
      zoneReco.innerHTML = html;
      zoneReco.hidden = false;
    }).catch(function () { cacherAccessoires(); });
  }

  /* ------------------------------------------------------------------ */
  /* Cadeau automatique — brosse démêlante offerte dès 80€                */
  /* ------------------------------------------------------------------ */
  // Mecanique 2 du brief original, confirmee EN PARALLELE du systeme plaid/
  // tapis/rouleau le 25/09/2026. Ajout/retrait automatiques uniquement :
  // jamais de +/- client sur cette ligne (voir ligne()). Le prix affiche ici
  // reste le prix catalogue tant qu aucune remise Shopify n a ete activee —
  // cote securite (remise reelle a 0€), voir la note dans la memoire du
  // chantier : une remise automatique Shopify s applique immediatement sur
  // TOUTE la boutique en ligne des qu elle est active, elle ne s active donc
  // jamais depuis ce fichier ni sans validation explicite de Sami.
  var cadeauEnCours = false;

  function ligneCadeau(panier, variantId) {
    for (var i = 0; i < panier.items.length; i++) {
      if (String(panier.items[i].variant_id) === String(variantId)) return panier.items[i];
    }
    return null;
  }

  // Sous-total "eligible" pour les deux paliers (80€/140€) : le total AVANT
  // toute remise (original_total_price), moins la valeur D ORIGINE du cadeau
  // (original_line_price, pas final_line_price). Verifie empiriquement le
  // 25/09/2026 face a la vraie remise Shopify (Achetez X obtenez Y) : celle-ci
  // evalue son propre seuil de 80€ sur le sous-total AVANT sa propre remise,
  // et la remise commande de 140€ evalue le sien sur le sous-total APRES la
  // remise cadeau mais AVANT la remise commande elle-meme — d ou l usage de
  // `original_total_price` (jamais pollue par une remise deja appliquee, donc
  // stable quel que soit l ordre de rendu) moins la valeur d origine du cadeau
  // (pas sa valeur actuelle, qui vaut 0€ des que la remise Shopify est active
  // et rendrait ce calcul instable/circulaire s il etait utilise ici).
  function sousTotalEligible(panier, variantIdCadeau) {
    var ligne = ligneCadeau(panier, variantIdCadeau);
    return panier.original_total_price - (ligne ? ligne.original_line_price : 0);
  }

  /* ---------- Barre de progression vers le cadeau ---------- */
  // Rendu "premium" demande explicitement par Sami le 25/09/2026 : degrade,
  // reflet anime en continu, marqueur qui s illumine au franchissement.
  // Un seul palier affiche (80€/brosse) : la remise 10€ a 140€ existe dans le
  // brief mais n a pas encore de mecanique reelle derriere — l afficher ici
  // promettrait quelque chose que le systeme ne tient pas encore.
  var zoneObjectif = racine.querySelector('[data-phcart-objectif]');

  function cacherObjectif() {
    if (!zoneObjectif) return;
    zoneObjectif.hidden = true;
    zoneObjectif.classList.remove('est--atteint');
  }

  function majObjectif(panier) {
    if (!zoneObjectif) return;
    if (!panier.item_count) { cacherObjectif(); return; }
    chargerAccessoires().then(function (data) {
      if (!data || !data.brosse) { cacherObjectif(); return; }
      var brosse = data.brosse;
      var remise = data.remise; // {seuil, montant} — palier 2, des le 26/09/2026
      var sousTotal = sousTotalEligible(panier, brosse.variantId);

      var seuil1 = Math.round(brosse.seuil * 100);
      var seuilFin = remise ? Math.round(remise.seuil * 100) : seuil1;
      var atteint1 = sousTotal >= seuil1;
      var atteint2 = remise ? sousTotal >= seuilFin : false;
      var pct = Math.max(0, Math.min(100, Math.round((sousTotal / seuilFin) * 100)));

      var barre = zoneObjectif.querySelector('[data-phcart-objectif-barre]');
      var texte = zoneObjectif.querySelector('[data-phcart-objectif-txt]');
      var m1 = zoneObjectif.querySelector('[data-phcart-marqueur="1"]');
      var m2 = zoneObjectif.querySelector('[data-phcart-marqueur="2"]');
      var l1 = zoneObjectif.querySelector('[data-phcart-label="1"]');
      var l2 = zoneObjectif.querySelector('[data-phcart-label="2"]');

      if (barre) barre.style.width = pct + '%';

      if (m1) {
        m1.style.left = ((seuil1 / seuilFin) * 100) + '%';
        m1.classList.toggle('est--atteint', atteint1);
      }
      if (m2) {
        m2.hidden = !remise;
        if (remise) { m2.style.left = '100%'; m2.classList.toggle('est--atteint', atteint2); }
      }
      if (l1) l1.textContent = prix(brosse.seuil * 100) + ' · offerte';
      if (l2) l2.textContent = remise ? prix(remise.seuil * 100) + ' · -' + prix(remise.montant * 100) : '';

      if (texte) {
        if (!atteint1) {
          texte.innerHTML = 'Plus que <strong>' + prix(seuil1 - sousTotal) + '</strong> pour votre brosse démêlante offerte';
        } else if (!remise) {
          texte.innerHTML = 'Brosse démêlante offerte débloquée !';
        } else if (!atteint2) {
          texte.innerHTML = 'Brosse offerte débloquée ! Plus que <strong>' + prix(seuilFin - sousTotal) + '</strong> pour ' + prix(remise.montant * 100) + ' de réduction';
        } else {
          texte.innerHTML = 'Brosse offerte et ' + prix(remise.montant * 100) + ' de réduction débloqués !';
        }
      }

      zoneObjectif.classList.toggle('est--atteint', remise ? atteint2 : atteint1);
      zoneObjectif.hidden = false;
    }).catch(function () { cacherObjectif(); });
  }

  function gererCadeauBrosse(panier) {
    if (cadeauEnCours) return;
    chargerAccessoires().then(function (data) {
      if (!data || !data.brosse) return;
      var brosse = data.brosse;
      var ligneExistante = ligneCadeau(panier, brosse.variantId);
      var sousTotal = sousTotalEligible(panier, brosse.variantId);
      var seuilCentimes = Math.round(brosse.seuil * 100);

      if (sousTotal >= seuilCentimes) {
        if (!ligneExistante) {
          cadeauEnCours = true;
          ajouter([{ id: brosse.variantId, quantity: 1, properties: { _cadeau_offert_80e: 'oui' } }])
            .then(function () { return lire().then(rendre); })
            .catch(function () { /* echec silencieux : pas de gift bloquant l achat */ })
            .then(function () { cadeauEnCours = false; });
        } else if (ligneExistante.quantity > 1) {
          // 1 max/commande : ecrete si jamais la quantite a change ailleurs.
          cadeauEnCours = true;
          changer(ligneExistante.key, 1)
            .then(rendre)
            .catch(function () {})
            .then(function () { cadeauEnCours = false; });
        }
      } else if (ligneExistante) {
        // Commande redevenue ineligible : retrait automatique, jamais
        // laisse en place a prix reduit ou gratuit.
        cadeauEnCours = true;
        changer(ligneExistante.key, 0)
          .then(rendre)
          .catch(function () {})
          .then(function () { cadeauEnCours = false; });
      }
    }).catch(function () {});
  }

  /* ------------------------------------------------------------------ */
  /* Carrousel d autres paniers — bas du tiroir                          */
  /* ------------------------------------------------------------------ */
  // Reprend, a l identique, la logique qui vivait avant le 25/09/2026 dans
  // "Complétez son confort" : ce catalogue ne vend que des couchages, les
  // seuls vrais complements sont un couchage POUR AILLEURS (voiture,
  // transport, tapis d appoint dans une autre piece). Seul le nom du bloc
  // et sa position (carrousel, bas du tiroir) changent — la logique metier
  // ne bouge pas.
  var FAMILLES = [
    // Deja un couchage de voiture ou de transport : on propose la maison.
    { motif: /voiture|transport|ceinture|caisse|sac/,
      cibles: ['panier-orthopedique-pour-chien', 'coussin-matelas-chien'] },
    // Deja un tapis ou un matelas : on propose un vrai panier a rebords.
    { motif: /tapis|matelas/,
      cibles: ['panier-orthopedique-pour-chien', 'panier-voiture-chien'] },
    // Cas courant : un panier de maison. La voiture et le transport sont
    // les seuls complements sinceres.
    { motif: /panier|coussin|niche|sofa|nid/,
      cibles: ['panier-voiture-chien', 'panier-transport-chien', 'coussin-matelas-chien'] }
  ];

  var cacheCollections = {};
  var cacheRelated = {};
  var recoEnCours = false;

  function familleDe(panier) {
    var texte = '';
    for (var i = 0; i < panier.items.length; i++) {
      texte += ' ' + (panier.items[i].handle || '') + ' ' + (panier.items[i].product_title || '');
    }
    texte = texte.toLowerCase();
    for (var f = 0; f < FAMILLES.length; f++) {
      if (FAMILLES[f].motif.test(texte)) return FAMILLES[f];
    }
    return null;
  }

  // Normalise une liste de produits de l API storefront.
  function normaliser(liste) {
    var sortie = [];
    for (var i = 0; i < (liste || []).length; i++) {
      var prod = liste[i];
      // Premiere variante DISPONIBLE, pas la premiere tout court : un
      // produit dont la taille de tete est epuisee reste vendable.
      var v = null, dispos = prod.variants || [];
      for (var d = 0; d < dispos.length; d++) { if (dispos[d].available) { v = dispos[d]; break; } }
      if (!v) continue;
      var centimes = Math.round(parseFloat(v.price) * 100);
      if (!centimes) continue;
      var img = '';
      if (prod.images && prod.images[0]) img = prod.images[0].src || prod.images[0];
      else if (prod.featured_image) img = prod.featured_image;
      sortie.push({
        id: prod.id,
        titre: prod.title,
        url: '/products/' + prod.handle,
        image: img,
        variante: v.id,
        centimes: centimes,
        // Toute la promesse de la boutique est de choisir la BONNE taille.
        // Ajouter une taille au hasard parce qu elle est la premiere
        // disponible fabriquerait des retours : des qu il y a un choix a
        // faire, on envoie sur la fiche.
        choixRequis: (prod.variants || []).length > 1
      });
    }
    return sortie;
  }

  function chargerCollection(handle) {
    if (cacheCollections[handle]) return Promise.resolve(cacheCollections[handle]);
    return fetch('/collections/' + handle + '/products.json?limit=12', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { cacheCollections[handle] = normaliser(j.products); return cacheCollections[handle]; })
      .catch(function () { cacheCollections[handle] = []; return []; });
  }

  // Repli : ce que Shopify calcule comme proche de cet article. Ce sont des
  // couchages de substitution, pas des complements — le titre du bloc change
  // en consequence, on ne fait pas passer un autre panier pour un accessoire.
  function chargerRelated(idProduit) {
    if (cacheRelated[idProduit]) return Promise.resolve(cacheRelated[idProduit]);
    return fetch('/recommendations/products.json?product_id=' + idProduit + '&limit=8&intent=related', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { cacheRelated[idProduit] = normaliser(j.products); return cacheRelated[idProduit]; })
      .catch(function () { cacheRelated[idProduit] = []; return []; });
  }

  function ecarterLePanier(candidats, panier) {
    var dedans = {};
    for (var i = 0; i < panier.items.length; i++) dedans[panier.items[i].product_id] = true;
    var out = [];
    for (var c = 0; c < candidats.length; c++) {
      if (!dedans[candidats[c].id]) out.push(candidats[c]);
    }
    return out;
  }

  function carteCarrousel(p) {
    var visuel = p.image ? p.image.replace(/(\.[a-z]+)(\?|$)/i, '_256x$1$2') : '';
    // Multi-variantes : un lien vers la fiche, pas un ajout. Mono-variante :
    // rien a choisir, donc ajout direct sans quitter le tiroir.
    var action = p.choixRequis
      ? '<a class="phcart-reco__action" href="' + p.url + '">Choisir</a>'
      : '<button type="button" class="phcart-reco__action" data-phcart-reco="' + p.variante + '">Ajouter</button>';
    return '<li class="phcart-carte-panier">' +
      (visuel ? '<a class="phcart-carte-panier__visuel" href="' + p.url + '"><img src="' + echapper(visuel) + '" alt="" loading="lazy" width="128" height="128"></a>' : '') +
      '<a class="phcart-carte-panier__titre" href="' + p.url + '">' + echapper(p.titre) + '</a>' +
      '<span class="phcart-carte-panier__prix">' + prix(p.centimes) + '</span>' +
      action +
    '</li>';
  }

  function cacherCarrousel() {
    if (!zoneCarrousel) return;
    zoneCarrousel.hidden = true;
    zoneCarrousel.innerHTML = '';
  }

  function recommanderPaniers(panier) {
    if (!zoneCarrousel) return Promise.resolve();
    if (!panier.item_count) { cacherCarrousel(); return Promise.resolve(); }

    var famille = familleDe(panier);
    var cibles = famille ? famille.cibles : [];

    var accumule = [];
    var suite = Promise.resolve();
    cibles.forEach(function (handle) {
      suite = suite.then(function () {
        // Collection suivante sollicitee seulement si le vivier reste maigre.
        if (ecarterLePanier(accumule, panier).length >= 2) return;
        return chargerCollection(handle).then(function (l) { accumule = accumule.concat(l); });
      });
    });

    return suite.then(function () {
      var retenus = ecarterLePanier(accumule, panier);
      if (retenus.length >= 2) return { liste: retenus.slice(0, 2), complement: true };
      return chargerRelated(panier.items[0].product_id).then(function (l) {
        var mix = ecarterLePanier(accumule.concat(l), panier);
        // Le titre ne dit « complement » que si TOUT ce qui est montre vient
        // des collections complementaires.
        return { liste: mix.slice(0, 2), complement: retenus.length >= mix.slice(0, 2).length && retenus.length > 0 };
      });
    }).then(function (res) {
      if (!res.liste.length) { cacherCarrousel(); return; }
      var titre = res.complement ? 'Pourrait aussi vous plaire' : 'À voir aussi';
      var html = '<p class="phcart__carrousel-titre">' + titre + '</p><ul class="phcart__carrousel-piste" role="list">';
      for (var i = 0; i < res.liste.length; i++) html += carteCarrousel(res.liste[i]);
      zoneCarrousel.innerHTML = html + '</ul>';
      zoneCarrousel.hidden = false;
    }).catch(function () { cacherCarrousel(); });
  }

  function ajouterReco(varianteId, bouton) {
    if (recoEnCours) return;
    recoEnCours = true;
    if (bouton) { bouton.disabled = true; bouton.textContent = '...'; }
    ajouter([{ id: varianteId, quantity: 1 }])
      .then(function () { return lire().then(rendre); })
      // Echec : on relit l etat reel plutot que de quitter le tiroir. La
      // page /cart native ne doit jamais s afficher en usage normal — voir
      // la note sur majQuantite plus bas, meme regle ici.
      .catch(function () { return lire().then(rendre).catch(function () {}); })
      .then(function () { recoEnCours = false; if (bouton) bouton.disabled = false; });
  }

  function rendre(panier) {
    if (!panier) return;
    var n = panier.item_count;

    if (compte) compte.textContent = n ? ' (' + n + ')' : '';
    majCompteurTheme(n);

    // La pastille suit le panier : elle apparait au premier article et
    // disparait quand il n en reste plus.
    if (bulle) bulle.hidden = !n;
    if (bulleCompte) bulleCompte.textContent = n || '';

    if (!n) {
      liste.innerHTML = '';
      if (vide) vide.hidden = false;
      if (pied) pied.hidden = true;
      // Panier vide : ni bandeau ni suggestions. Le bandeau parlerait d une
      // commande qui n existe pas encore.
      if (zoneLivraison) zoneLivraison.hidden = true;
      cacherAccessoires();
      cacherCarrousel();
      cacherObjectif();
      return;
    }
    if (zoneLivraison) zoneLivraison.hidden = false;
    if (vide) vide.hidden = true;
    if (pied) pied.hidden = false;

    construireListe(panier);

    ecrire('[data-phcart-total]', prix(panier.total_price));
    ecrire('[data-phcart-cta-total]', '· ' + prix(panier.total_price));

    rendreReductions(panier);
    majObjectif(panier);
    recommanderAccessoires(panier);
    recommanderPaniers(panier);
    gererCadeauBrosse(panier);
  }

  /* ------------------------------------------------------------------ */
  /* Ouverture / fermeture                                               */
  /* ------------------------------------------------------------------ */
  function ouvrir() {
    dernierFocus = document.activeElement;
    racine.classList.add('is--ouvert');
    racine.setAttribute('aria-hidden', 'false');
    document.body.classList.add('phcart-ouvert');
    var f = racine.querySelector('[data-phcart-fermer]');
    if (f) f.focus();
  }

  function fermer() {
    racine.classList.remove('is--ouvert');
    racine.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('phcart-ouvert');
    if (dernierFocus && dernierFocus.focus) dernierFocus.focus();
  }

  function rafraichirPuisOuvrir() {
    return lire().then(function (p) { rendre(p); ouvrir(); });
  }

  /* ------------------------------------------------------------------ */
  /* Interception — delegation globale, jamais de liaison par element     */
  /* ------------------------------------------------------------------ */
  // Kalles pose ses propres gestionnaires sur le CLIC des boutons d ajout, et
  // fait son appel reseau sans jamais laisser le formulaire emettre
  // d evenement submit. On se place donc en phase de CAPTURE sur le document,
  // qui s execute avant tout gestionnaire pose plus bas dans l arbre, et on
  // stoppe la propagation pour rester seul maitre du panier.
  //
  // Le bouton de paiement express est volontairement exclu : il mene
  // directement au paiement, ce n est pas un ajout au panier.
  document.addEventListener('click', function (e) {
    var cible = e.target;
    if (!cible || !cible.closest) return;
    if (cible.closest('.shopify-payment-button')) return;

    var bouton = cible.closest('[name="add"], [data-atc-form], button[type="submit"]');
    if (!bouton) return;
    var form = bouton.form || bouton.closest('form');
    if (!form || !form.action || form.action.indexOf('/cart/add') < 0) return;
    if (!formulairePret(form)) return;

    e.preventDefault();
    e.stopPropagation();
    soumettre(form);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') < 0) return;
    if (!formulairePret(form)) return;
    if (enCours) { e.preventDefault(); return; }
    e.preventDefault();
    soumettre(form);
  }, true);

  // Un formulaire d ajout sans identifiant de variante n est pas encore
  // pret : la fiche produit laisse le champ vide tant que toutes les options
  // ne sont pas choisies. On ne prend alors PAS la main, pour que la
  // validation du theme puisse s exprimer normalement.
  function formulairePret(form) {
    try {
      return new FormData(form).getAll('id').filter(function (v) { return v; }).length > 0;
    } catch (e) { return false; }
  }

  function soumettre(form) {
    if (enCours) return;
    var donnees = new FormData(form);

    var identifiants = donnees.getAll('id').filter(function (v) { return v; });
    var quantites = donnees.getAll('quantity').filter(function (v) { return v; });

    // Sans identifiant de variante on ne tente rien : le navigateur saura
    // faire mieux que nous avec le formulaire natif.
    if (!identifiants.length) { form.__phRepli = true; form.submit(); return; }

    // Les proprietes de ligne s appliquent a toutes les variantes du
    // formulaire, comme le fait Shopify avec ce format.
    var proprietes = null;
    donnees.forEach(function (valeur, cle) {
      if (cle.indexOf('properties[') === 0) {
        proprietes = proprietes || {};
        proprietes[cle.slice(11, -1)] = valeur;
      }
    });

    var items = identifiants.map(function (id, rang) {
      // Une seule quantite pour plusieurs variantes : elle vaut pour toutes.
      var brute = quantites.length > 1 ? quantites[rang] : quantites[0];
      var article = { id: id, quantity: parseInt(brute, 10) || 1 };
      if (proprietes) article.properties = proprietes;
      return article;
    });

    enCours = true;
    verrouiller(form, true);

    ajouter(items)
      .then(rafraichirPuisOuvrir)
      .catch(function () {
        // Echec reseau ou refus du serveur : on rend la main au comportement
        // natif plutot que de laisser le visiteur bloque. Le marqueur evite
        // que le detournement de submit() nous renvoie ici en boucle.
        form.__phRepli = true;
        form.submit();
      })
      .then(function () { enCours = false; verrouiller(form, false); });
  }

  function verrouiller(form, etat) {
    var b = form.querySelector('[type="submit"], [name="add"]');
    if (b) { b.disabled = etat; b.classList.toggle('is--chargement', etat); }
  }

  // Icone panier du header : reste un vrai lien vers /cart dans le HTML, on
  // n annule la navigation qu au moment du clic. Comme pour l ajout, Kalles
  // pose son propre gestionnaire sur ce lien pour ouvrir SON tiroir : on passe
  // donc en capture et on coupe la propagation, sinon les deux tiroirs
  // s ouvriraient l un sur l autre.
  //
  // Clic milieu, Cmd/Ctrl/Maj : on ne touche a rien, le visiteur veut un
  // nouvel onglet et doit l obtenir.
  document.addEventListener('click', function (e) {
    var lien = e.target.closest ? e.target.closest('a[href$="/cart"], a[href*="/cart?"]') : null;
    if (!lien) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    e.stopPropagation();
    // La page /cart native ne doit jamais s afficher en usage normal (regle
    // explicite du 26/09/2026) : un echec ici rouvre simplement le tiroir
    // avec le dernier etat connu plutot que de quitter vers /cart.
    rafraichirPuisOuvrir().catch(function () { ouvrir(); });
  }, true);

  // Quantites, suppression, fermeture, pastille.
  racine.addEventListener('click', function (e) {
    var cible = e.target;
    if (!cible.closest) return;

    if (cible.closest('[data-phcart-fermer]') || cible.closest('[data-phcart-voile]')) {
      fermer();
      return;
    }
    if (cible.closest('[data-phcart-bulle]')) {
      rafraichirPuisOuvrir().catch(function () { ouvrir(); });
      return;
    }

    var reco = cible.closest('[data-phcart-reco]');
    if (reco) {
      ajouterReco(reco.getAttribute('data-phcart-reco'), reco);
      return;
    }

    var art = cible.closest('[data-cle]');
    if (!art) return;
    var cle = art.getAttribute('data-cle');

    if (cible.closest('[data-phcart-retirer]')) {
      majQuantite(cle, 0);
      return;
    }
    var bouton = cible.closest('[data-phcart-qte]');
    if (bouton) {
      // Part de la derniere quantite DEMANDEE (quantiteConnue), pas du DOM :
      // un deuxieme clic rapide, avant que le premier n ait eu de reponse du
      // serveur, verrait sinon le MEME chiffre affiche que le premier clic
      // et calculerait la meme cible — le second clic n aurait alors aucun
      // effet net. Voir la file d attente par ligne dans majQuantite().
      var cleActuelle = Object.prototype.hasOwnProperty.call(quantiteConnue, cle)
        ? quantiteConnue[cle]
        : parseInt(art.querySelector('[data-phcart-qte-valeur]').textContent, 10) || 1;
      var nouvelleQuantite = Math.max(0, cleActuelle + parseInt(bouton.getAttribute('data-phcart-qte'), 10));
      // Retour visuel immediat : le chiffre bouge des le clic, sans
      // attendre l aller-retour reseau — c est precisement ce que Sami a
      // signale comme manquant le 26/09/2026.
      var valeurAffichee = art.querySelector('[data-phcart-qte-valeur]');
      if (valeurAffichee && nouvelleQuantite > 0) valeurAffichee.textContent = nouvelleQuantite;
      majQuantite(cle, nouvelleQuantite);
    }
  });

  // File d attente PAR LIGNE, pas un verrou global. L ancien code posait
  // un seul drapeau `enCours` partage par tout le tiroir ET affichait
  // `is--occupe` (pointer-events: none SUR TOUT LE TIROIR, cf.
  // ph-cart-style.liquid) des le premier clic sur un +/- : resultat, chaque
  // clic suivant — meme sur le MEME bouton, meme un instant apres — n
  // atteignait jamais le JS, bloque par le CSS. Vu et signale par Sami le
  // 26/09/2026 : le numero du selecteur semblait "bloque" alors que le
  // total, lui, finissait par refleter le denier clic applique. Corrige en
  // ne bloquant plus qu au niveau de la LIGNE concernee, et en memorisant
  // la derniere quantite demandee pendant qu une requete est deja en vol
  // pour cette ligne plutot que de jeter le clic : aucun clic perdu, plus
  // besoin d assombrir tout le tiroir pour rester coherent.
  var majEnCoursParCle = {};
  var majEnAttenteParCle = {};
  // Derniere quantite DEMANDEE par ligne (optimiste, avant confirmation
  // serveur) — c est elle que le clic relit, jamais le DOM seul, pour que
  // des clics rapproches s additionnent au lieu de se pietiner.
  var quantiteConnue = {};

  function majQuantite(cle, quantite) {
    quantite = Math.max(0, quantite);
    quantiteConnue[cle] = quantite;
    if (majEnCoursParCle[cle]) {
      majEnAttenteParCle[cle] = quantite;
      return;
    }
    majEnCoursParCle[cle] = true;
    // On ne rend JAMAIS la reponse brute de /cart/change.js : son format
    // pour cart_level_discount_applications est different de celui de
    // /cart.js (imbrique sous `discount_application` au lieu d etre a plat)
    // — trouve le 26/09/2026 via une remise a 140€ genuinement declenchee
    // par un +/- sur une ligne dans un Pack Confort. rendreReductions()
    // attend le format de /cart.js : on relit toujours via lire() avant de
    // rendre, comme le font deja ajouterReco/rafraichirPuisOuvrir.
    changer(cle, quantite)
      .then(function () { return lire(); })
      .then(rendre)
      // La page /cart native ne doit JAMAIS s afficher en usage normal —
      // regle explicite du 26/09/2026, apres un cas reel de suppressions
      // multiples ayant fait atterrir un client dessus. Un echec (reseau,
      // ou une exception dans rendre()) relit simplement l etat reel du
      // panier et retente l affichage dans le tiroir ; /cart ne reste un
      // recours que si le tiroir lui-meme est introuvable (racine absente
      // des le chargement du script, cf. tout en haut du fichier).
      .catch(function () { return lire().then(rendre).catch(function () {}); })
      .then(function () {
        majEnCoursParCle[cle] = false;
        if (Object.prototype.hasOwnProperty.call(majEnAttenteParCle, cle)) {
          var suivante = majEnAttenteParCle[cle];
          delete majEnAttenteParCle[cle];
          majQuantite(cle, suivante);
        } else {
          // Ligne stabilisee : le rendu qui vient de s executer fait foi,
          // plus besoin de la valeur optimiste.
          delete quantiteConnue[cle];
        }
      });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (racine.classList.contains('is--ouvert')) fermer();
  });

  /* ------------------------------------------------------------------ */
  /* Filet reseau                                                        */
  /* ------------------------------------------------------------------ */
  // Une application tierce peut ecrire dans le panier sans passer par un
  // formulaire. Sans ce filet, le tiroir afficherait un etat perime.
  var CHEMINS_PANIER = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var CHEMIN_AJOUT = /\/cart\/add/;

  function estNotreAppel(options) {
    try {
      var h = options && options.headers;
      if (!h) return false;
      if (typeof h.get === 'function') return !!h.get('X-PaniHome-Panier');
      return !!h['X-PaniHome-Panier'];
    } catch (e) { return false; }
  }

  function reagirAuChangement(estUnAjout) {
    // Un court delai laisse l application qui vient d ecrire finir son
    // travail : certaines enchainent add puis change pour poser une propriete
    // de ligne, et lire trop tot afficherait un panier a moitie constitue.
    if (estUnAjout) reagirAuChangement.ouvrir = true;
    clearTimeout(reagirAuChangement.minuteur);
    reagirAuChangement.minuteur = setTimeout(function () {
      var ouvrirLeTiroir = reagirAuChangement.ouvrir;
      reagirAuChangement.ouvrir = false;
      if (ouvrirLeTiroir) {
        rafraichirPuisOuvrir().catch(function () { /* le lien natif reste */ });
      } else {
        lire().then(rendre).catch(function () { /* rien de visible a faire */ });
      }
    }, 220);
  }

  var fetchOrigine = window.fetch;
  if (typeof fetchOrigine === 'function') {
    window.fetch = function (entree, options) {
      var url = typeof entree === 'string' ? entree : (entree && entree.url) || '';
      var promesse = fetchOrigine.apply(this, arguments);
      if (CHEMINS_PANIER.test(String(url)) && !estNotreAppel(options)) {
        var estUnAjout = CHEMIN_AJOUT.test(String(url));
        promesse.then(function (r) {
          if (r && r.ok) reagirAuChangement(estUnAjout);
        }).catch(function () { /* l appelant gere son propre echec */ });
      }
      return promesse;
    };
  }

  // Certaines applications passent encore par XMLHttpRequest.
  var ouvrirXHR = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (methode, url) {
    this.__phUrlPanier = CHEMINS_PANIER.test(String(url || ''));
    this.__phEstAjout = CHEMIN_AJOUT.test(String(url || ''));
    return ouvrirXHR.apply(this, arguments);
  };
  var envoyerXHR = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var requete = this;
    if (requete.__phUrlPanier) {
      requete.addEventListener('load', function () {
        if (requete.status >= 200 && requete.status < 300) reagirAuChangement(requete.__phEstAjout);
      });
    }
    return envoyerXHR.apply(this, arguments);
  };

  // Dernier trou : form.submit() appele par un script ne declenche AUCUN
  // evenement submit, il quitte donc la page vers /cart sans que rien ne
  // puisse l intercepter. On detourne les seuls formulaires d ajout.
  var soumettreOrigine = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    var action = this.getAttribute('action') || '';
    if (action.indexOf('/cart/add') >= 0 && !this.__phRepli) {
      soumettre(this);
      return;
    }
    return soumettreOrigine.apply(this, arguments);
  };

  racine.setAttribute('aria-hidden', 'true');

  // Etat initial : on peuple le tiroir sans l ouvrir, pour que le compteur et
  // les totaux soient justes des le premier clic.
  lire().then(rendre).catch(function () { /* le lien natif suffit */ });
})();
